export const educationData = [
    {
        id: 1,
        institution: 'University of California Santa Cruz',
        course: 'B.S. Computer Science',
        startYear: '2019',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Stockdale High School',
        course: 'High School Diploma',
        startYear: '2015',
        endYear: '2019'
    },
]